import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
// import userManager from './userManager';
import { AUTHREQ, OPERATOR_STATUS } from '../../../constants/constants';
import { useObserver } from './ObserverContext';
import { useOperator } from './OperatorContext';
import { useEmail } from './EmailContext';
import { useUserManager } from './UserManagerContext';
import { createUserManager } from './userManager';
import { useRobotDetails } from '../../RobotDetailsContext';
import { useMaintenanceMode } from './MaintenanceContext';


export const AppRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const {isOperator, setIsOperator, setCanDrive} = useOperator();
  const {canMaintain, setCanMaintain} = useMaintenanceMode();
  const { isObserver, setIsObserver } = useObserver();  // Get the observer state
  const { userEmail, setUserEmail } = useEmail();
  const { userManager, setUserManager } = useUserManager()
  const routeRobot = window.location.pathname.split('/')[1]
  const { setRobot } = useRobotDetails();
  

  useEffect(() => {
    console.log("Checking user authentication status...");
    setRobot(routeRobot)
  
    const handleUserAuthentication = async () => {
      let activeUserManager = userManager
      try {
        let user = null
        
        if (userManager === null){
          console.log("User Manager not set")
          activeUserManager = await createUserManager(routeRobot)
          setUserManager( activeUserManager)
          user = await activeUserManager.getUser();
        }else{
          activeUserManager = userManager;
          user = await userManager.getUser();
        }
         
  
        // If the user is null, attempt silent sign-in
        if (!user) {
          console.log("User is not authenticated, attempting silent sign-in...");
          user = await activeUserManager.signinSilent();
        }
  
        if (user) {
          // console.log("User is authenticated", user);
          console.log("User is authenticated");
          // Process user details here
          const observerClaims = user.profile['groups'];
          
          if (observerClaims.includes('Observer')) {
            setIsObserver(true);
          } else {
            setIsObserver(false);
          }
          if (user.profile['email']){
            setUserEmail(user.profile['email'])
            console.log(`User email : ${user.profile['email']}`)
          }
          if (observerClaims.includes('Maintenance')) {
            setCanMaintain(true);
          }
          if (observerClaims.includes('CanDrive')) {
            setCanDrive(true);
          }else{
            setCanDrive(false);
          }


          if (observerClaims.includes('AdvancedOperator')) {
            setIsOperator(true);
            setCanMaintain(true);
            setCanDrive(true)
          } else {
            setIsOperator(false);
          }
          // Extract robot from route param and compare with entitlement
          
          const userEntitlement = user.profile['entitlements']?.[0];

          if (routeRobot && userEntitlement && routeRobot !== userEntitlement) {
            console.warn(`Entitlement mismatch: route = ${routeRobot}, entitlement = ${userEntitlement}`);
            
            await userManager.signoutRedirect();
            return;
          }
  
          setIsAuthenticated(true);
        } else {
          // Redirect to login if silent sign-in fails
          console.log("Silent sign-in failed, redirecting to login...");
          await activeUserManager.signinRedirect({ state: { targetUrl: rest.location?.pathname } });
        }
      } catch (error) {
        console.error("Error during user authentication check", error);
        activeUserManager.signinRedirect({ state: { targetUrl: rest.location?.pathname } });
      } finally {
        setIsLoading(false);
      }
    };
  
    if (AUTHREQ) {
      setIsLoading(true); // Start loading state
      handleUserAuthentication();
    } else {
      setCanMaintain(true)
      setIsAuthenticated(true);
    }
  }, [rest.location?.pathname]);
  
  

  useEffect(() => {
    // This effect checks the authentication status to avoid re-triggering the redirect
    if (isAuthenticated) {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null; // Or a loading spinner if preferred
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

AppRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType.isRequired,
};
